import { useCallback, useContext } from 'react';
import MetricUsageLookupContext from '../../../../../contexts/MetricUsageLookupContext';
import isDefined from '../../../../../isDefined';
import MetricsContext from '../../../../../contexts/MetricsContext';
import { getMetricLink } from '../../../AllSets/routes';
import { PortalsContext } from '../../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';

const useGetUnusedMetrics = () => {
  const { metricLookup } = useContext(MetricUsageLookupContext);
  const { allMetrics } = useContext(MetricsContext);
  const { selectedPortal } = useContext(PortalsContext);

  const getUnusedMetrics = useCallback(() => {
    return allMetrics
      .filter((metric) => metric.status !== 'archived')
      .map((metric) => {
        const lookup = metricLookup[metric.id];
        if (!lookup) return undefined;

        return {
          id: metric.id,
          usageCount: lookup.usageCount,
          name: metric.name,
          link: getMetricLink({
            metric,
            portal: selectedPortal,
          }),
        };
      })
      .filter(isDefined)
      .filter((metricLookup) => metricLookup?.usageCount === 0);
  }, [allMetrics, metricLookup, selectedPortal]);

  return getUnusedMetrics;
};

export default useGetUnusedMetrics;
